import React from "react";
import { Entry } from "@/features/entries/components/Entry";
import { useEntries } from "@/hooks/firestore/betting/useEntries";
import { EntrySkeleton } from "@/features/entries/components/pages/EntrySkeleton";
import { Typography } from "@picklebet/ui";
import { PageMessage } from "@picklebet/ui";
import NextBettingButtons from "@/features/shell/components/shared/NextBettingButtons";
import { useIsMobile } from "@/hooks/useDisplay";
import { useCashOut } from "@/features/entries/hooks/useCashOut";
import { useEligibleEntries } from "@/features/entries/hooks/useEligibleEntries";
import { StatusMessage } from "@/features/betslip/components/StatusMessage";
import { ReactComponent as UpcomingIcon } from "@/features/entries/assets/upcoming.svg";
import { ImpressionTrackingProvider } from "@picklebet/telemetry/react";
import { telemetry } from "utilities/telemetry";

import * as styles from "./BetsList.module.scss";

const PendingBets = () => {
  const { entries, loading } = useEntries({
    tab: ["live", "upcoming"],
    page: 1,
    perPage: 10,
    limitToEntryType: "BET",
  });

  const eligibleEntries = useEligibleEntries(entries ?? []);

  const { getCashoutPropsByReferenceId } = useCashOut(eligibleEntries);

  const isMobile = useIsMobile();
  const btnVariant = isMobile ? "primary" : "blurred";

  if (loading) {
    return <EntrySkeleton />;
  }

  if (!entries?.length) {
    return (
      <StatusMessage>
        <PageMessage
          className={styles.entryMessage}
          image={<UpcomingIcon />}
          title={`No Pending Entries`}
          subTitle={
            <>
              <Typography variant={`body`} noSpacing>
                Check out today's action to make a bet
              </Typography>
            </>
          }
        >
          <NextBettingButtons
            className={styles.entryButtons}
            variant={btnVariant}
            size="md"
          />
        </PageMessage>
      </StatusMessage>
    );
  }

  return (
    <ImpressionTrackingProvider telemetry={telemetry}>
      <div className={styles.entries}>
        {entries.map((entry) => (
          <Entry
            key={entry.entryId}
            entry={entry}
            isCompact
            cashOut={getCashoutPropsByReferenceId(entry.referenceId)}
          />
        ))}
      </div>
    </ImpressionTrackingProvider>
  );
};

PendingBets.displayName = "PendingBets";

export default PendingBets;
